import { useEffect } from 'react';

export const useHeightObserver = ({ selector, callback, deps = [] }) => {
  const heightObserverCallback = mutationList => {
    // check for any mutation changes related to nodes modifications or styles attributes modifications
    const needRecheckHeight = !!mutationList.find(
      mutation =>
        mutation.type === 'childList' || mutation.attributeName === 'style' || mutation.attributeName === 'class',
    );

    // if mutation that may affect content height is present then send offsetHeight for check
    if (needRecheckHeight) {
      try {
        callback({ height: document?.querySelector(selector)?.offsetHeight });
      } catch (e) {
        // handling not required
      }
    }
  };

  useEffect(() => {
    callback({ height: document?.querySelector(selector)?.offsetHeight });
    // Please fix this when you touch this file
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    const heightObserver = new MutationObserver(heightObserverCallback);

    const targetNode = document?.querySelector(selector);
    const observerOptions = {
      childList: true,
      attributes: true,
      subtree: true,
    };

    if (targetNode) {
      heightObserver.observe(targetNode, observerOptions);
    }

    return () => {
      heightObserver?.disconnect();
    };
    // Please fix this when you touch this file
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
